export default "__VITE_ASSET__6fe4110a__"